import { render, staticRenderFns } from "./TabSectionPreButtons.vue?vue&type=template&id=6c6f4cc4"
import script from "./TabSectionPreButtons.vue?vue&type=script&lang=ts"
export * from "./TabSectionPreButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports